module.exports = __webpack_public_path__ + "static/media/dark-whatsapp.6f050b67.jpg";